var map = {
	"./pollution_data_bergamopm10": [
		821,
		821
	],
	"./pollution_data_bergamopm10.json": [
		821,
		821
	],
	"./pollution_data_bergamopm25": [
		13,
		13
	],
	"./pollution_data_bergamopm25.json": [
		13,
		13
	],
	"./pollution_data_trevigliopm10": [
		331,
		331
	],
	"./pollution_data_trevigliopm10.json": [
		331,
		331
	],
	"./pollution_data_trevigliopm25": [
		567,
		567
	],
	"./pollution_data_trevigliopm25.json": [
		567,
		567
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 487;
module.exports = webpackAsyncContext;